module.exports = __webpack_public_path__ + "img/solo.622cbf8e.png";